module.exports = __webpack_public_path__ + "img/bonus_respin_feature.a2a5222d.png";